import { render } from "./Flow.vue?vue&type=template&id=6b13efd6"
import script from "./Flow.vue?vue&type=script&lang=js"
export * from "./Flow.vue?vue&type=script&lang=js"

import "./Flow.vue?vue&type=style&index=0&id=6b13efd6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/project/Flow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b13efd6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b13efd6', __exports__)) {
    api.reload('6b13efd6', __exports__)
  }
  
  module.hot.accept("./Flow.vue?vue&type=template&id=6b13efd6", () => {
    api.rerender('6b13efd6', render)
  })

}


export default __exports__